const COLOR_SWATCH_PATH = '/content/dam/breville-brands/global/swatch/';
// visible algolia hits (filtering away hits such as 'Legacy')
const AVAILABLE_WEB_STATUS = ['Visible for Sale', 'Visible but not for Sale'];
/**
 * Format price for display
 * @param {number} price (1200.99)
 * @param {boolean?} showDecimals whether to round the value
 * @param {number} fractionDigits Min/Max fraction digits to show decimal point
 * @returns {string} display price
 */
const currencyConverter = (price, fractionDigits = 2, options) => {
    const { locale, currencyCode } = options;
    // Below if is to check incoming price arg has text like 'FREE' or not
    if (price === 0) {
        return price;
    }
    if ((locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === 'ko-kr') {
        fractionDigits = 0;
    }
    const currencyFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    });
    return currencyFormatter.format(price);
};
/**
 * This method will format price based on the config from CT
 * Derived from xps-utils, but this is pure function, no deps needed from aemGlobalConfig.
 * @param {DecisionTools.CTPrice} ctPrice priceobject from CT
 * @param {double} quantity this is optional params if not passed default is 1
 * @returns {string} formatted price
 */
function formatPrice(ctPrice, quantity = 1, options = { locale: 'en-US', currencyCode: 'USD' }) {
    if (!ctPrice)
        return undefined;
    const { centAmount, fractionDigits = 0 } = ctPrice;
    if (!centAmount)
        return 'FREE';
    const price = (centAmount * quantity) / (Math.pow(10, fractionDigits));
    const intlPrice = currencyConverter(price, fractionDigits, options);
    return intlPrice;
}
/**
 * helper to grab attribute from ct variant response
 * @param {object} variant ct variant
 * @param {string} attrName (WEB_STATUS, COLOUR_TRANSLATION) raw attribute name
 * @returns {object} result
 */
function getAttrFromVariant(variant, attrName) {
    var _a, _b;
    // GRAPHQL response
    if (variant === null || variant === void 0 ? void 0 : variant.attributesRaw) {
        return (_b = (_a = variant === null || variant === void 0 ? void 0 : variant.attributesRaw) === null || _a === void 0 ? void 0 : _a.find((attr) => attr.name.toLowerCase() === attrName.toLowerCase())) === null || _b === void 0 ? void 0 : _b.value;
    }
    // REST response
    // Disabled since type and data do not exist.
    // if (variant?.attributes) {
    //   return variant?.attributes?.find((attr: any) => attr.name.toLowerCase() === attrName.toLowerCase())?.value;
    // }
    return null;
}
function tryJsonParse(jsonString) {
    try {
        return JSON.parse(jsonString);
    }
    catch (err) {
        return null;
    }
}
function getVariantAttr(variant, attrName, locale) {
    const rawAttr = getAttrFromVariant(variant, attrName);
    const lookAttr = (rawAttr === null || rawAttr === void 0 ? void 0 : rawAttr[locale]) || (rawAttr === null || rawAttr === void 0 ? void 0 : rawAttr['en']);
    return tryJsonParse(lookAttr);
}
/* If status list includes correct webchannel and status then allow */
const _compareStatusWithWebChannel = (status, webChannel) => {
    if (typeof status === 'string') {
        return AVAILABLE_WEB_STATUS.some((status) => status.toLowerCase() === status.toLowerCase());
    }
    if (Array.isArray(status)) {
        return status.some(({ channel, value }) => Boolean(channel === webChannel && AVAILABLE_WEB_STATUS.some((status) => status.toLowerCase() === value.toLowerCase())));
    }
    return false;
};
const getAllVariants = (masterData, aemConfig) => {
    if (!masterData) {
        return [];
    }
    const { locale, webChannel } = aemConfig, variants = [masterData.masterVariant, ...((masterData === null || masterData === void 0 ? void 0 : masterData.variants) || [])].filter((variant) => {
        const webStatusRaw = getAttrFromVariant(variant, 'WEB_STATUS');
        // if no web status attribute provided then do not use
        if (!(webStatusRaw && (webStatusRaw === null || webStatusRaw === void 0 ? void 0 : webStatusRaw[locale]))) {
            return false;
        }
        // webStatus could be an array of objects or a single object
        const webStatus = tryJsonParse(webStatusRaw[locale]);
        return _compareStatusWithWebChannel(webStatus, webChannel);
    });
    // Order based on WEB_TS_COLOUR_ORDER
    return variants.sort((variantA, variantB) => {
        const aOrderRaw = getAttrFromVariant(variantA, 'WEB_TS_COLOUR_ORDER'), bOrderRaw = getAttrFromVariant(variantB, 'WEB_TS_COLOUR_ORDER'), aOrder = aOrderRaw ? (parseInt(tryJsonParse(aOrderRaw === null || aOrderRaw === void 0 ? void 0 : aOrderRaw[locale])) || 99) : 99, bOrder = bOrderRaw ? (parseInt(tryJsonParse(bOrderRaw === null || bOrderRaw === void 0 ? void 0 : bOrderRaw[locale])) || 99) : 99;
        return aOrder - bOrder;
    });
};
const getAvailability = (variant, aemConfig) => {
    var _a, _b, _c, _d;
    if (!variant)
        return null;
    const { webChannel } = aemConfig;
    const availability = (_d = (_c = (_b = (_a = variant.availability) === null || _a === void 0 ? void 0 : _a.channels) === null || _b === void 0 ? void 0 : _b.results) === null || _c === void 0 ? void 0 : _c.find((result) => { var _a; return ((_a = result.channel) === null || _a === void 0 ? void 0 : _a.name) === webChannel; })) === null || _d === void 0 ? void 0 : _d.availability;
    return availability ? availability : null;
};
const getMasterAttr = (masterData, attrName, locale = 'en') => {
    var _a;
    const attrData = masterData[attrName];
    return (_a = attrData === null || attrData === void 0 ? void 0 : attrData.find((attr) => attr.locale === locale)) === null || _a === void 0 ? void 0 : _a.value;
};

export { AVAILABLE_WEB_STATUS, COLOR_SWATCH_PATH, currencyConverter, formatPrice, getAllVariants, getAttrFromVariant, getAvailability, getMasterAttr, getVariantAttr, tryJsonParse };
//# sourceMappingURL=utils.js.map
